import { AddOnType } from '@mc/storefront-core'

export { Page } from '../../prcng-451_v1_on_call_add_on/events/types'

export const ProductName: AddOnType = 'certificate_program' as const
